import { Pipe, PipeTransform } from '@angular/core';
import { StatusEnum } from '../definition/enum/status.enum';
import { UserStatusEnum } from '../../module/iam/user-settings/enum/user-status.enum';

@Pipe({ name: 'StatusCssClass' })
export class StatusCssClassPipe implements PipeTransform {
    public transform(status: StatusEnum | UserStatusEnum): string {
        if (status === StatusEnum.COMPLETED || status === UserStatusEnum.ACTIVE) {
            return 'ui-icon-success';
        } else if (status === StatusEnum.EXECUTING) {
            return 'ui-icon-activated';
        } else {
            return 'ui-icon-regular';
        }
    }
}
